import { emitter } from "@/App";
import DxfParser from "@/commons/components/dxf-parser/DxfParser";
import { Emit_Event } from "@/commons/enums/emit-event";
import DxfToEntityUtil from "@/commons/utils/DxfToEntityUtil";
import TnMessage from "@/commons/widget/message";
import { Spin, Upload, message } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";

export default function ImportDxf(second) {

    const { projectUuid, branchUuid, modelUuid } = useParams()

    // const [loading, setLoading] = useState<boolean>(false)

    const beforeUpload = (file) => {
        let typeList = file.name.split(".")
        let type = typeList[typeList.length - 1]
        if (type == "dxf") {
            let reader = new FileReader();
            // setFilename(file.name)
            reader.onloadend = onSuccess;
            reader.onabort = abortUpload;
            reader.onerror = errorHandler;
            reader.readAsText(file, "UTF-8");
        }
        // props.setMenuVisible(false)
        return false
    }

    const onSuccess = (event) => {
        let file = { uuid: projectUuid };
        var fileReader = event.target;

        if (fileReader.error) return console.log("error onloadend!");
        var parser = new DxfParser();
        var dxf = parser.parseSync(fileReader.result);
        let dxfToGraphic = new DxfToEntityUtil();
        dxfToGraphic.projectUuid = projectUuid;
        dxfToGraphic.branchUuid = branchUuid;
        dxfToGraphic.modelUuid = modelUuid
        // setLoading(true)
        emitter.emit(Emit_Event.LOADING_DXF, true)
        dxfToGraphic.Viewer(dxf, file).then(res => {
            // setLoading(false)

            window.location.reload();
        });
    }

    const abortUpload = () => {
        console.log('Aborted read');
    }

    const errorHandler = (event) => {

        switch (event.target.error.code) {
            case event.target.error.NOT_FOUND_ERR:
                alert('File Not Found!');
                TnMessage.error("文件未找到！")
                break;
            case event.target.error.NOT_READABLE_ERR:
                alert('File is not readable');
                TnMessage.error("文件读取失败！")
                break;
            case event.target.error.ABORT_ERR:
                TnMessage.error("导入失败！")
                break; // noop
            default:
                TnMessage.error("导入失败！")
                alert('An error occurred reading this file.');
        }
        emitter.emit(Emit_Event.LOADING_DXF, false)
    }


    return (
        // <Spin spinning={loading}>
        <Upload
            name='file'
            showUploadList={false}
            beforeUpload={beforeUpload}>
            <div style={{ cursor: "pointer", marginLeft: "10px" }}>
                导入DXF
            </div>
        </Upload>
        // </Spin>
    )
}